<template>
    <div class="layout">
        <sidebar :show-awl="false" :show-logout="false"/>
        <div class="login-container">
            <div class="login-modal">
                <div class="login-title">{{ $t('pages.login.title') }}</div>
                <div class="login-footer">
                    <button
                        class="button button-blue"
                        @click="login"
                    >
                        {{ $t('pages.login.submit') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';

export default {
    name: 'Login',
    components: {
        Sidebar,
    },
    methods: {
        login() {
            this.$store.dispatch('auth/login');
        },
    },
    /* data() {
        return {
            email: '',
            password: '',
            error: null,
        };
    },
    methods: {
        async onSubmit() {
            if (this.email === '' || this.password === '') {
                this.error = this.$t('auth.login.errors.missing_error');
                return;
            }

            const credentials = {
                email: this.email,
                password: this.password,
            };

            try {
                const response = await this.$store.dispatch('auth/login', credentials);
                if (response === true) {
                    this.error = null;
                    this.$router.replace({ name: 'checklists' });
                } else {
                    this.error = this.$t('auth.login.errors.auth_error');
                }
            } catch (err) {
                this.error = this.$t('auth.login.errors.server_error');
            }
        },
    }, */
};

/*
<form
    actions=""
    method="post"
    class="login-modal"
    @submit.prevent="onSubmit()"
>
    <div class="login-title">{{ $t('pages.login.title') }}</div>
    <div class="login-input">
        <label class="login-input-label" for="login-email">
            {{ $t('pages.login.username') }}
        </label>
        <input
            v-model="email"
            type="email"
            name="email"
            id="login-email"
            class="login-input-text"
            :placeholder="$t('pages.login.username')"
        />
    </div>
    <div class="login-input">
        <label class="login-input-label" for="login-password">
            {{ $t('pages.login.password') }}
        </label>
        <input
            v-model="password"
            type="password"
            name="password"
            id="login-password"
            class="login-input-text"
            :placeholder="$t('pages.login.password')"
        />
        <div v-if="error" class="login-input-error">{{ error }}</div>
    </div>
    <div class="login-footer">
        <button type="submit" class="button button-blue">
            {{ $t('pages.login.submit') }}
        </button>
    </div>
</form>
*/

</script>
